import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Transition as _Transition, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/i.png';
const _hoisted_1 = {
    key: 0,
    class: "topPanel"
};
const _hoisted_2 = { key: 1 };
const _hoisted_3 = {
    key: 2,
    class: "transactionHistoryInfo"
};
const _hoisted_4 = {
    key: 0,
    class: "transactionHistory"
};
const _hoisted_5 = {
    key: 3,
    class: "archive-section"
};
const _hoisted_6 = { class: "drawer-body giftDrawerBody" };
const _hoisted_7 = { class: "giftText" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "drawer-body" };
const _hoisted_10 = ["src"];
const _hoisted_11 = {
    key: 1,
    class: "remaining"
};
const _hoisted_12 = { class: "ease-of-use-box" };
const _hoisted_13 = { class: "text-caption mb-2" };
const _hoisted_14 = { class: "star-rating" };
const _hoisted_15 = { class: "text-caption mt-1" };
import { ref, computed, watch, onMounted, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import { useEmployer } from '@/composables/useEmployer';
import { useContent } from '@/composables/useContent';
import { usePolling } from '@/composables/usePolling';
import HeaderBlock from './elements/HeaderBlock.vue';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import VoucherTransactionsList from './elements/VoucherTransactionsList.vue';
import MGButton from './elements/MGButton.vue';
import MGDialog from './elements/MGDialog.vue';
import VoucherCarousel from './VoucherCarousel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MyVouchersForMerchantPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, getEmployer } = useCustomer();
        const vouchers = useVouchers();
        const { isMoneyGuided } = useEmployer();
        const content = useContent();
        const { poll } = usePolling('voucher-transactions');
        const purchaseInput = useTemplateRef('purchaseInput');
        const purchaseTotal = ref(null);
        const spendErrorText = ref(null);
        const confirmationErrorText = ref(null);
        const isDrawerOpen = ref(false);
        const showGuide = ref(false);
        const showGiftDrawer = ref(false);
        const showRedemptionModal = ref(false);
        const showArchiveConfirmationModal = ref(false);
        const previousRedemption = ref(null);
        const actualAmount = ref(null);
        const actualAmountError = ref(null);
        const easeOfUseRating = ref(0);
        const easeOfUseSubmitted = ref(false);
        const guide = ref(null);
        const currentDialogPage = ref('confirmation');
        const selectedVouchers = ref([]);
        const selectedVoucher = ref(0);
        const selectedVouchersKey = ref(0);
        const archiveClicked = ref(false);
        const fromArchived = ref(false);
        const fromWallet = ref(false);
        const cardUrl = ref(null);
        const spendingInProgress = ref(false);
        watch(selectedVoucher, (newIndex) => {
            state.voucher = selectedVouchers.value[newIndex];
            checkPreviousRedemption(state.voucher);
        });
        watch(() => state.voucher, (newVoucher) => {
            if (newVoucher && newVoucher.customerVoucherTransactions) {
                newVoucher.customerVoucherTransactions = [...newVoucher.customerVoucherTransactions]
                    .sort((a, b) => new Date(b.createdDateTime).getTime() - new Date(a.createdDateTime).getTime());
            }
        }, { immediate: true });
        const spendButtonText = computed(() => {
            console.log('Computing spendButtonText with purchaseTotal:', purchaseTotal.value, 'and voucher currentBalance:', state.voucher.currentBalance);
            const amount = purchaseTotal.value !== null ? purchaseTotal.value : state.voucher.currentBalance;
            return `Spend ${state.formatter.format(amount)}`;
        });
        function preventNegative(event) {
            if (event.key === '-' || event.key === 'e') {
                event.preventDefault();
            }
        }
        function calcRemaining() {
            if (purchaseTotal.value === null || purchaseTotal.value === undefined || purchaseTotal.value === '') {
                return state.voucher.currentBalance;
            }
            const remaining = state.voucher.currentBalance - purchaseTotal.value;
            return remaining >= 0 ? remaining : 0;
        }
        function fillFullAmount() {
            purchaseTotal.value = state.voucher.currentBalance;
            validatePurchaseAmount();
        }
        function validatePurchaseAmount() {
            if (purchaseTotal.value === '.') {
                purchaseTotal.value = 0;
            }
            if (purchaseTotal.value === '') {
                purchaseTotal.value = null;
            }
            if (purchaseTotal.value === null || purchaseTotal.value === undefined) {
                spendErrorText.value = null;
                return;
            }
            spendErrorText.value = null;
            const purchaseAmount = Number(purchaseTotal.value);
            if (purchaseAmount > state.voucher.currentBalance) {
                spendErrorText.value = `Please enter an amount no more than ${state.formatter.format(state.voucher.currentBalance)}`;
            }
            else if (purchaseAmount < 0) {
                purchaseTotal.value = 0;
                spendErrorText.value = 'Please enter a positive amount';
            }
        }
        function validateActualAmount() {
            if (actualAmount.value === null || actualAmount.value === undefined || actualAmount.value === '') {
                confirmationErrorText.value = null;
                return;
            }
            confirmationErrorText.value = null;
            var maxAmount = Number(previousRedemption.value.newCurrentBalance) + Number(previousRedemption.value.amount);
            if (actualAmount.value > maxAmount) {
                confirmationErrorText.value = `Must be no more than ${state.formatter.format(maxAmount)}`;
                actualAmount.value = maxAmount;
            }
            else if (actualAmount.value <= 0) {
                actualAmount.value = 0;
                confirmationErrorText.value = 'Please enter a positive amount';
            }
        }
        function fetchVouchers(callback) {
            console.log('Fetching vouchers for merchant', route.params.id);
            if (fromArchived.value) {
                vouchers.getCustomerVoucher(route.params.id, () => {
                    selectedVouchers.value = [state.voucher];
                    handleVoucherData(callback);
                });
            }
            else if (fromWallet.value) {
                vouchers.getCustomerVoucher(route.params.id, () => {
                    var voucher = state.voucher;
                    var merchantId = voucher.discount.merchant.id;
                    vouchers.getCustomerVouchers(() => {
                        console.log(route.params.id);
                        selectedVouchers.value = state.vouchers.vouchers;
                        state.voucher = selectedVouchers.value.find((v) => v.id == route.params.id);
                        handleVoucherData(callback);
                    }, merchantId, false);
                });
            }
            else {
                console.log('Fetching vouchers for merchant normally with merchant ID:', route.params.id);
                vouchers.getCustomerVouchers(() => {
                    console.log('Vouchers fetched:', state.vouchers);
                    selectedVouchers.value = state.vouchers.vouchers;
                    state.voucher = selectedVouchers.value[0];
                    console.log('Selected vouchers:', selectedVouchers.value);
                    handleVoucherData(callback);
                }, route.params.id, fromArchived.value, true);
            }
        }
        function handleVoucherData(callback) {
            selectedVouchers.value.forEach((voucher) => {
                checkPreviousRedemption(voucher);
            });
            const merchantName = selectedVouchers.value[0]?.discount?.merchant?.name?.replaceAll("&", '')?.toUpperCase();
            if (merchantName) {
                content.getCmsArticleByKey(`VG_${merchantName.substring(0, 10)}`, (article) => {
                    if (article) {
                        guide.value = article;
                    }
                });
            }
            if (callback)
                callback();
        }
        function getSelectedVouchers(callback) {
            console.log('Getting selected vouchers');
            fetchVouchers(callback);
        }
        function pollForVouchers(shouldStop, callback) {
            poll({
                remaining: 10,
                interval: 1000,
                fetch: (onSuccess) => {
                    vouchers.clearCustomerVouchers();
                    fetchVouchers(onSuccess);
                },
                onPoll: () => { },
                shouldStop,
                onFinish: () => {
                    selectedVouchersKey.value++;
                    if (callback)
                        callback();
                }
            });
        }
        function transactionDeleted(transaction) {
            pollForVouchers(() => {
                return !state.voucher?.customerVoucherTransactions?.some((t) => t.id === transaction.id);
            });
        }
        function transactionUpdated(transaction, newAmount) {
            pollForVouchers(() => {
                const txn = state.voucher?.customerVoucherTransactions?.find((t) => t.id === transaction.id);
                return txn && txn.amount === newAmount;
            });
        }
        function openDrawer() {
            isDrawerOpen.value = true;
            spendingInProgress.value = false;
            purchaseTotal.value = null;
            actualAmount.value = previousRedemption.value?.amount || 0;
            setTimeout(() => {
                if (purchaseInput.value && purchaseInput.value.focus) {
                    purchaseInput.value.focus();
                }
            }, 300);
        }
        function closeDrawer() {
            isDrawerOpen.value = false;
        }
        function addVoucherTransactionFn(amount) {
            if (amount === null) {
                amount = state.voucher.currentBalance;
            }
            if (purchaseTotal.value > state.voucher.currentBalance) {
                return;
            }
            spendingInProgress.value = true;
            const previousTxnCount = state.voucher.customerVoucherTransactions?.length || 0;
            const voucherUrl = state.voucher.url;
            vouchers.addVoucherTransaction(state.voucher.id, amount, (transaction) => {
                saveRedemptionToStorage(amount, transaction);
                if (isDrawerOpen.value) {
                    closeDrawer();
                }
                pollForVouchers(() => {
                    return (state.voucher?.customerVoucherTransactions?.length || 0) > previousTxnCount;
                }, () => {
                    window.location = voucherUrl;
                });
            });
        }
        function saveRedemptionToStorage(amount, transaction) {
            const redemption = {
                merchantId: state.voucher.discount.merchant.id,
                merchantName: state.voucher.discount.merchant.name,
                amount: amount,
                date: new Date().toISOString(),
                voucherId: state.voucher.id,
                transactionId: transaction ? transaction.id : null,
                confirmed: false,
                easeOfUseRating: easeOfUseRating.value,
                newCurrentBalance: state.voucher.currentBalance - amount,
                cardUrl: state.voucher.discount.cardUrl
            };
            const existingRedemptions = JSON.parse(localStorage.getItem('voucherRedemptions') || '[]');
            existingRedemptions.push(redemption);
            localStorage.setItem('voucherRedemptions', JSON.stringify(existingRedemptions));
        }
        function checkPreviousRedemption(voucher) {
            if (!voucher || !voucher.discount.merchant)
                return;
            const merchantId = voucher.discount.merchant.id;
            const existingRedemptions = JSON.parse(localStorage.getItem('voucherRedemptions') || '[]');
            const merchantRedemptions = existingRedemptions
                .filter((r) => r.merchantId === merchantId && !r.confirmed)
                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
            if (merchantRedemptions.length > 0) {
                const mostRecent = merchantRedemptions[0];
                if (!mostRecent.amount || !mostRecent.date || !mostRecent.merchantName) {
                    console.warn('Invalid redemption data found:', mostRecent);
                    return;
                }
                const redemptionDate = new Date(mostRecent.date);
                const now = new Date();
                const daysDifference = Math.floor((now.getTime() - redemptionDate.getTime()) / (1000 * 60 * 60 * 24));
                if (daysDifference <= 7) {
                    previousRedemption.value = mostRecent;
                    currentDialogPage.value = 'confirmation';
                    actualAmount.value = mostRecent.amount;
                    cardUrl.value = mostRecent.cardUrl;
                    showRedemptionModal.value = true;
                }
            }
        }
        function confirmPreviousRedemption() {
            if (previousRedemption.value.amount != actualAmount.value) {
                confirmActualAmount();
            }
            if (previousRedemption.value) {
                deleteRedemptionFromStorage(previousRedemption.value);
                if (easeOfUseRating.value > 0 && !easeOfUseSubmitted.value) {
                    const easeOfUseData = {
                        id: state.voucher.id,
                        score: easeOfUseRating.value
                    };
                    vouchers.addVoucherEaseOfUse(easeOfUseData, () => {
                        console.log('Ease of use review added:', easeOfUseRating.value);
                    });
                    easeOfUseSubmitted.value = true;
                }
            }
            showRedemptionModal.value = false;
            previousRedemption.value = null;
            easeOfUseRating.value = 0;
            easeOfUseSubmitted.value = false;
            currentDialogPage.value = 'confirmation';
        }
        function viewVoucher() {
            if (isDrawerOpen.value) {
                closeDrawer();
            }
            window.location = state.voucher.url;
        }
        async function buildLogoFile(url) {
            try {
                const blob = await (await fetch(url)).blob();
                return new File([blob], 'voucher.jpg', { type: blob.type || 'image/jpeg' });
            }
            catch {
                return null; // ponytail: logo fetch failed (CORS/offline) — share text only
            }
        }
        function confirmSendGift() {
            showGiftDrawer.value = false;
            sendAsGift();
        }
        async function sendAsGift() {
            const voucher = state.voucher;
            const faceValue = state.formatter.format(Number(voucher.faceValue), false, false);
            const merchant = voucher.discount.merchant.name;
            const link = voucher.url;
            const balanceLine = voucher.currentBalance < voucher.faceValue
                ? ` It has ${state.formatter.format(Number(voucher.currentBalance), false, false)} remaining.`
                : '';
            const text = `I just gifted you a ${faceValue} ${merchant} voucher from Money Guided.${balanceLine} Here is the link for you to redeem it: ${link}`;
            try {
                if (navigator.share) {
                    const file = await buildLogoFile(voucher.discount.cardUrl);
                    if (file && navigator.canShare?.({ files: [file] })) {
                        await navigator.share({ text, files: [file] });
                    }
                    else {
                        await navigator.share({ text });
                    }
                }
                else {
                    await navigator.clipboard.writeText(text);
                }
            }
            catch (err) {
                if (err.name === 'AbortError')
                    return; // user cancelled share — don't archive
                console.error('Share failed', err);
            }
            confirmArchiveVoucher();
        }
        function archiveVoucherFn() {
            showArchiveConfirmationModal.value = true;
        }
        function confirmArchiveVoucher() {
            showArchiveConfirmationModal.value = false;
            archiveClicked.value = true;
            vouchers.archiveVoucher(state.voucher.id, () => {
                vouchers.clearCustomerVouchers();
                vouchers.getCustomerVouchers(() => {
                    if (fromWallet.value) {
                        router.push({ path: '/Wallet' });
                        return;
                    }
                    router.push('/MyVouchers/Merchants');
                }, null, null, false, true);
            });
        }
        function unarchiveVoucherFn() {
            archiveClicked.value = true;
            vouchers.unarchiveVoucher(state.voucher.id, () => {
                vouchers.clearCustomerVouchers();
                vouchers.getCustomerVouchers(() => {
                    router.push('/Wallet');
                }, null, null, false, true);
            });
        }
        function cancelArchiveVoucher() {
            showArchiveConfirmationModal.value = false;
        }
        function buyVoucher() {
            router.replace({ path: '/vouchers/amount/' + state.voucher.discount.id });
        }
        function deleteRedemptionFromStorage(redemption) {
            const existingRedemptions = JSON.parse(localStorage.getItem('voucherRedemptions') || '[]');
            const updatedRedemptions = existingRedemptions.filter((r) => {
                return !(r.merchantId === redemption.merchantId &&
                    r.amount === redemption.amount &&
                    r.date === redemption.date &&
                    r.voucherId === redemption.voucherId);
            });
            localStorage.setItem('voucherRedemptions', JSON.stringify(updatedRedemptions));
        }
        function updateRedemptionAmount(redemption) {
            const existingRedemptions = JSON.parse(localStorage.getItem('voucherRedemptions') || '[]');
            const updatedRedemptions = existingRedemptions.filter((r) => {
                return !(r.merchantId === redemption.merchantId &&
                    r.amount === redemption.amount &&
                    r.date === redemption.date &&
                    r.voucherId === redemption.voucherId &&
                    r.transactionId === redemption.transactionId);
            });
            localStorage.setItem('voucherRedemptions', JSON.stringify(updatedRedemptions));
        }
        function confirmActualAmount() {
            if (!actualAmount.value || actualAmount.value <= 0) {
                return;
            }
            const newAmount = parseFloat(actualAmount.value);
            const redemption = previousRedemption.value;
            const currentBalance = parseFloat(redemption.newCurrentBalance);
            const originalAmount = parseFloat(redemption.amount);
            if (currentBalance + originalAmount - newAmount < 0) {
                actualAmountError.value = 'The actual amount cannot exceed the current balance.';
                return;
            }
            actualAmountError.value = null;
            if (redemption) {
                updateRedemptionAmount(redemption);
                if (redemption.transactionId) {
                    vouchers.updateVoucherTransaction(redemption.voucherId, redemption.transactionId, newAmount, () => {
                        pollForVouchers(() => {
                            const txn = state.voucher?.customerVoucherTransactions?.find((t) => t.id === redemption.transactionId);
                            return txn && txn.amount === newAmount;
                        });
                    });
                }
                else {
                    console.error('No transaction ID found in redemption:', redemption);
                }
            }
            showRedemptionModal.value = false;
            actualAmount.value = '';
            actualAmountError.value = null;
            previousRedemption.value = null;
            easeOfUseRating.value = 0;
            easeOfUseSubmitted.value = false;
            currentDialogPage.value = 'confirmation';
        }
        function removeTransaction() {
            if (previousRedemption.value && previousRedemption.value.transactionId) {
                deleteRedemptionFromStorage(previousRedemption.value);
                vouchers.deleteVoucherTransaction(previousRedemption.value.voucherId, previousRedemption.value.transactionId, () => {
                    vouchers.clearCustomerVouchers();
                    getSelectedVouchers();
                });
            }
            showRedemptionModal.value = false;
            actualAmount.value = '';
            previousRedemption.value = null;
            easeOfUseRating.value = 0;
            easeOfUseSubmitted.value = false;
        }
        onMounted(() => {
            fromArchived.value = route.query.archive === 'true';
            fromWallet.value = route.query.fromWallet === 'true';
            getCustomer(() => {
                if (state.customer?.employerID)
                    getEmployer(state.customer.employerID);
                getSelectedVouchers();
            });
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: _unref(state).voucher ? _unref(state).voucher.discount.merchant.name : 'Voucher'
                }, null, 8, ["title"]),
                (_unref(state).customer && _unref(state).voucher)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(VoucherCarousel, {
                            items: selectedVouchers.value,
                            formatter: _unref(state).formatter,
                            paginationDots: true,
                            visibleDots: 5,
                            defaultVoucherId: _unref(state).voucher ? _unref(state).voucher.id : null,
                            onVoucherSelected: _cache[0] || (_cache[0] = ($event) => (selectedVoucher.value = $event))
                        }, null, 8, ["items", "formatter", "defaultVoucherId"]),
                        (_unref(state).voucher.currentBalance > 0)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                class: "button-row"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "button-col" }, {
                                        default: _withCtx(() => [
                                            _createVNode(MGButton, {
                                                text: "Spend voucher",
                                                stacked: true,
                                                fullWidth: true,
                                                onClick: _cache[1] || (_cache[1] = ($event) => (openDrawer()))
                                            }),
                                            _createVNode(MGButton, {
                                                text: "View voucher",
                                                stacked: true,
                                                textOnly: true,
                                                fullWidth: true,
                                                onClick: _cache[2] || (_cache[2] = ($event) => (viewVoucher()))
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_unref(state).voucher.currentBalance == 0)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 1,
                                class: "button-row"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "button-col" }, {
                                        default: _withCtx(() => [
                                            (_unref(state).voucher.currentBalance == 0)
                                                ? (_openBlock(), _createBlock(MGButton, {
                                                    key: 0,
                                                    text: "View voucher",
                                                    stacked: true,
                                                    noCaps: true,
                                                    fullWidth: true,
                                                    onClick: _cache[3] || (_cache[3] = ($event) => (viewVoucher()))
                                                }))
                                                : _createCommentVNode("", true),
                                            (_unref(state).voucher.currentBalance == 0)
                                                ? (_openBlock(), _createBlock(MGButton, {
                                                    key: 1,
                                                    text: "Buy another voucher",
                                                    noCaps: true,
                                                    stacked: true,
                                                    fullWidth: true,
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (buyVoucher()))
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_v_skeleton_loader, {
                            type: "image, heading",
                            class: "topPanel"
                        })
                    ])),
                (_unref(state).customer && _unref(state).voucher)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_v_row, {
                            justify: "center",
                            class: "constrained-row"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "text-center" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("h2", null, [
                                            _cache[21] || (_cache[21] = _createTextVNode("Transaction History ")),
                                            _createElementVNode("img", {
                                                src: _imports_0,
                                                class: "info-icon",
                                                onClick: _cache[5] || (_cache[5] = ($event) => (_unref(router).push('/TrackYourSpend')))
                                            })
                                        ])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_row, { class: "mt-4 constrained-row" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "note" }, {
                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createElementVNode("span", null, "Keep track of your spending to make every penny count.", -1)
                                    ])),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).voucher)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_v_row, { class: "mt-0" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, { class: "right" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("Balance: " + _toDisplayString(_unref(state).formatter.format(_unref(state).voucher.currentBalance)), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                (_openBlock(), _createBlock(VoucherTransactionsList, {
                                    key: selectedVouchersKey.value,
                                    onTransactionDeleted: transactionDeleted,
                                    onTransactionUpdated: transactionUpdated,
                                    search: "false",
                                    localVoucher: _unref(state).voucher,
                                    formatter: _unref(state).formatter,
                                    today: _unref(state).today,
                                    yesterday: _unref(state).yesterday
                                }, null, 8, ["localVoucher", "formatter", "today", "yesterday"]))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (_unref(state).voucher && (_unref(state).voucher.archived !== true || _unref(state).voucher.currentBalance > 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_unref(state).voucher.archived !== true)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                class: "button-row"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "button-col" }, {
                                        default: _withCtx(() => [
                                            (_unref(isMoneyGuided) && _unref(state).voucher.currentBalance > 0)
                                                ? (_openBlock(), _createBlock(MGButton, {
                                                    key: 0,
                                                    text: "Send as Gift",
                                                    icon: "mdi-gift",
                                                    stacked: true,
                                                    fullWidth: true,
                                                    disabled: archiveClicked.value,
                                                    noCaps: true,
                                                    onClick: _cache[6] || (_cache[6] = ($event) => (showGiftDrawer.value = true))
                                                }, null, 8, ["disabled"]))
                                                : _createCommentVNode("", true),
                                            _createVNode(MGButton, {
                                                text: "Archive Voucher",
                                                stacked: true,
                                                fullWidth: true,
                                                outline: true,
                                                noCaps: true,
                                                disabled: archiveClicked.value,
                                                onClick: _cache[7] || (_cache[7] = ($event) => (archiveVoucherFn()))
                                            }, null, 8, ["disabled"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_unref(state).voucher.archived == true && _unref(state).voucher.currentBalance > 0)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 1,
                                class: "button-row mt-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "button-col" }, {
                                        default: _withCtx(() => [
                                            _createVNode(MGButton, {
                                                text: "Unarchive Voucher",
                                                fullWidth: true,
                                                outline: true,
                                                disabled: archiveClicked.value,
                                                onClick: _cache[8] || (_cache[8] = ($event) => (unarchiveVoucherFn()))
                                            }, null, 8, ["disabled"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (_unref(state).voucher)
                    ? (_openBlock(), _createBlock(SimpleDrawerPanel, {
                        key: 4,
                        modelValue: showGiftDrawer.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((showGiftDrawer).value = $event)),
                        title: "Send as Gift",
                        height: "auto",
                        closeButton: true
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("p", _hoisted_7, "We'll create a shareable link for your " + _toDisplayString(_unref(state).voucher.discount.merchant.name) + " voucher so you can send it to someone.", 1),
                                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "giftText" }, "Once shared, this voucher will be archived and removed from your wallet — whoever opens the link can redeem the remaining balance, so only send it to someone you trust.", -1)),
                                _createVNode(_component_v_row, { class: "spendbutton" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(MGButton, {
                                                    text: "Share gift link",
                                                    icon: "mdi-gift",
                                                    flat: true,
                                                    fullWidth: true,
                                                    onClick: _cache[9] || (_cache[9] = ($event) => (confirmSendGift()))
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                (guide.value)
                    ? (_openBlock(), _createBlock(SimpleDrawerPanel, {
                        key: 5,
                        modelValue: showGuide.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((showGuide).value = $event)),
                        title: "How To Use Guide",
                        height: "88vh"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("iframe", {
                                src: '/#/articles/' + guide.value.id,
                                style: { "border": "0px", "width": "100%", "height": "100%" }
                            }, null, 8, _hoisted_8)
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                (_unref(state).voucher)
                    ? (_openBlock(), _createBlock(SimpleDrawerPanel, {
                        key: 6,
                        modelValue: isDrawerOpen.value,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((isDrawerOpen).value = $event)),
                        height: "88vh",
                        title: "Spend voucher",
                        closeButton: true
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                                (_unref(state).voucher.currentBalance > 0)
                                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, { class: "purchaseLabel" }, {
                                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                    _createElementVNode("b", null, "Track your spend", -1),
                                                    _createElementVNode("br", null, null, -1),
                                                    _createElementVNode("span", { class: "purchaseText" }, "Enter the amount you'll be spending.", -1)
                                                ])),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                class: "right",
                                                cols: "2"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                        class: "cardLogo",
                                                        src: _unref(state).voucher.discount.cardUrl
                                                    }, null, 8, _hoisted_10)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_row, { class: "amount-row" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                (_unref(state).voucher.currentBalance > 0)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                        key: 0,
                                                        ref_key: "purchaseInput",
                                                        ref: purchaseInput,
                                                        variant: "solo",
                                                        flat: true,
                                                        clearable: "",
                                                        "single-line": "",
                                                        rounded: "",
                                                        outlined: "",
                                                        prefix: "£",
                                                        modelValue: purchaseTotal.value,
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((purchaseTotal).value = $event)),
                                                        type: "text",
                                                        inputmode: "decimal",
                                                        onInput: validatePurchaseAmount,
                                                        onKeydown: _cache[13] || (_cache[13] = ($event) => (preventNegative($event))),
                                                        placeholder: _unref(state).voucher.currentBalance,
                                                        label: "Enter amount"
                                                    }, null, 8, ["modelValue", "placeholder"]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                (_unref(state).voucher.currentBalance > 0)
                                    ? (_openBlock(), _createBlock(_component_v_row, {
                                        key: 1,
                                        class: "remaining-row"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    (!spendErrorText.value)
                                                        ? (_openBlock(), _createElementBlock("span", {
                                                            key: 0,
                                                            class: "remaining clickable",
                                                            onClick: fillFullAmount
                                                        }, [
                                                            _cache[25] || (_cache[25] = _createTextVNode(" Remaining: ")),
                                                            _createElementVNode("b", null, _toDisplayString(_unref(state).formatter.format(calcRemaining())), 1)
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_11, " Please enter an amount no more than " + _toDisplayString(_unref(state).formatter.format(_unref(state).voucher.currentBalance)) + ". ", 1))
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_row, { class: "spendbutton" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                (_unref(state).voucher.currentBalance > 0)
                                                    ? (_openBlock(), _createBlock(MGButton, {
                                                        key: 0,
                                                        text: spendButtonText.value,
                                                        onClick: _cache[14] || (_cache[14] = ($event) => (addVoucherTransactionFn(purchaseTotal.value))),
                                                        flat: true,
                                                        fullWidth: true,
                                                        disabled: spendingInProgress.value
                                                    }, null, 8, ["text", "disabled"]))
                                                    : _createCommentVNode("", true),
                                                (!_unref(state).voucher.currentBalance > 0)
                                                    ? (_openBlock(), _createBlock(MGButton, {
                                                        key: 1,
                                                        fullWidth: true,
                                                        text: "View",
                                                        onClick: _cache[15] || (_cache[15] = ($event) => (viewVoucher())),
                                                        flat: true
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                _createVNode(MGDialog, {
                    modelValue: showArchiveConfirmationModal.value,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((showArchiveConfirmationModal).value = $event)),
                    "max-width": "500px",
                    persistent: true,
                    "content-height": "100px"
                }, {
                    content: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createElementVNode("p", null, "Are you sure you want to archive this voucher?", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            fullWidth: true,
                            text: "Confirm",
                            onClick: confirmArchiveVoucher
                        }),
                        _createVNode(MGButton, {
                            stacked: true,
                            fullWidth: true,
                            outline: true,
                            text: "Cancel",
                            onClick: cancelArchiveVoucher
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showRedemptionModal.value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((showRedemptionModal).value = $event)),
                    "max-width": "500px",
                    persistent: true,
                    title: "Confirmation",
                    icon: cardUrl.value,
                    "content-height": "180px"
                }, {
                    content: _withCtx(() => [
                        _cache[27] || (_cache[27] = _createElementVNode("h2", { class: "confirmation-header" }, "Track your spend", -1)),
                        _cache[28] || (_cache[28] = _createElementVNode("p", { class: "confirmation-text" }, "Confirm the amount you spent.", -1)),
                        _createVNode(_component_v_text_field, {
                            modelValue: actualAmount.value,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((actualAmount).value = $event)),
                            label: "Enter amount",
                            type: "text",
                            inputmode: "decimal",
                            prefix: "£",
                            variant: "solo",
                            flat: true,
                            clearable: "",
                            "single-line": "",
                            outlined: "",
                            rounded: "",
                            onKeydown: _cache[19] || (_cache[19] = ($event) => (preventNegative($event))),
                            onInput: validateActualAmount,
                            autofocus: "",
                            onKeyup: _withKeys(confirmActualAmount, ["enter"])
                        }, null, 8, ["modelValue"]),
                        (confirmationErrorText.value)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                class: "confirmAlert",
                                density: "compact",
                                type: "info",
                                icon: false,
                                variant: "plain",
                                text: confirmationErrorText.value
                            }, null, 8, ["text"]))
                            : _createCommentVNode("", true)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            noCaps: true,
                            stacked: true,
                            fullWidth: true,
                            class: "button-row",
                            text: "Save",
                            onClick: confirmPreviousRedemption,
                            disabled: !previousRedemption.value
                        }, null, 8, ["disabled"]),
                        _createVNode(MGButton, {
                            noCaps: true,
                            stacked: true,
                            fullWidth: true,
                            class: "button-row",
                            outline: true,
                            text: "I didn't spend anything",
                            onClick: removeTransaction,
                            disabled: !previousRedemption.value
                        }, null, 8, ["disabled"])
                    ]),
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("p", _hoisted_13, "How easy was it to use this voucher at " + _toDisplayString(_unref(state).voucher.discount.merchant.name) + "? (Optional)", 1),
                            _createElementVNode("div", _hoisted_14, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                                    return _createVNode(_component_v_icon, {
                                        key: star,
                                        style: _normalizeStyle(star <= easeOfUseRating.value ? 'background: #413655; -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;' : 'color: #cccccc;'),
                                        onClick: ($event) => (easeOfUseRating.value = star),
                                        class: "star-icon",
                                        size: "24"
                                    }, {
                                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                                            _createTextVNode(" mdi-star ")
                                        ])),
                                        _: 2
                                    }, 1032, ["style", "onClick"]);
                                }), 64))
                            ]),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(easeOfUseRating.value > 0 ? `${easeOfUseRating.value} out of 5 stars` : ''), 1)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue", "icon"])
            ], 64));
        };
    }
});
